/* spx-completa-envio — «Completa tu envío gratis» en el carrito (25/09/2026, auditoría multi-modelo).
 *
 * Bajo la barra de envío gratis del carrito (página y cajón) sugiere hasta 3 productos que, AGREGADOS
 * SOLOS, dejan el despacho gratis: con stock, que no estén ya en el carro, precio ≥ lo que falta, del
 * más barato al más caro. Primero los relacionados con lo que hay en el carro (recomendaciones de
 * Shopify) y después una colección curada de la tienda.
 * Medido en Simplit (90 d): 115 pedidos quedaron entre $60.000 y $89.989, justo bajo el umbral.
 *
 * Configuración por tienda, antes de cargar este archivo:
 *   window.SPX_COMPLETA = { umbral: 8999000, anclas: ['.ajax-cart__free-shipping'], tema: 'icon',
 *                           coleccion: 'favoritos', color: '#2f2f2f' };
 *   umbral en centavos · anclas = selectores de la barra de envío (de ahí se lee lo que falta) ·
 *   pagar = selector del botón de pago (la caja va después de él; por defecto [name=checkout]) ·
 *   tema 'icon' (Simplit) u 'horizon' (Lhotse, unionx.cl): decide cómo se refresca el carro.
 *
 * Fuente única: areas/paginas-propias/_comun/tema/spx-completa-envio.js · lo sube cada
 * `<tienda>/tema/completa-envio.py`.
 */
(function () {
  var C = window.SPX_COMPLETA;
  if (!C || window.__spxCompleta) return;
  window.__spxCompleta = 1;

  var fmt = function (c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (x) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[x]; }); };
  var cacheRec = {}, cacheCol = null, firma = '', trabajando = false, pendiente = false;

  function estilos() {
    if (document.getElementById('spx-completa-css')) return;
    var s = document.createElement('style');
    s.id = 'spx-completa-css';
    s.textContent =
      '.spx-completa{width:auto;max-width:100%;box-sizing:border-box;margin:12px 0 2px;padding:14px 14px 12px;border:1px solid #e7e5e4;border-radius:12px;background:#fff;text-align:left}' +
      '.spx-completa *{box-sizing:border-box}' +
      '.spx-completa__tit{margin:0;font-size:15px;font-weight:700;line-height:1.3;color:#1f2937}' +
      '.spx-completa__sub{margin:2px 0 10px;font-size:12.5px;line-height:1.35;color:#6b7280}' +
      '.spx-completa__lista{display:flex;flex-direction:column;gap:10px;margin:0;padding:0;list-style:none}' +
      '.spx-completa__item{display:flex;align-items:center;gap:10px}' +
      '.spx-completa__img{flex:0 0 56px;width:56px;height:56px;border-radius:8px;object-fit:cover;background:#f5f5f4}' +
      '.spx-completa__info{flex:1 1 auto;min-width:0}' +
      '.spx-completa__nom{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:13px;line-height:1.3;color:#1f2937;text-decoration:none}' +
      '.spx-completa__precio{margin-top:2px;font-size:13px;font-weight:700;color:#1f2937}' +
      '.spx-completa__precio s{margin-left:6px;font-weight:400;color:#9ca3af}' +
      '.spx-completa .spx-completa__btn{position:static;display:inline-flex;align-items:center;justify-content:center;width:auto;flex:0 0 auto;min-width:84px;height:36px;margin:0;padding:0 12px;text-decoration:none;box-shadow:none;border:1.5px solid var(--spx-c,#2f2f2f);border-radius:18px;background:#fff;color:var(--spx-c,#2f2f2f);font:600 13px/1 inherit;letter-spacing:0;text-transform:none;cursor:pointer}' +
      '.spx-completa .spx-completa__btn:hover{background:var(--spx-c,#2f2f2f);color:#fff}' +
      '.spx-completa .spx-completa__btn[aria-disabled=true]{opacity:.6;pointer-events:none}';
    document.head.appendChild(s);
  }

  function normalizarJs(p) { // /recommendations/products.json y /products/x.js: precios en centavos
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return null;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    return { id: p.id, titulo: p.title, url: p.url || ('/products/' + p.handle), img: img, precio: v.price,
             antes: v.compare_at_price || 0, variante: v.id, tipo: p.type || '' };
  }

  function normalizarColeccion(p) { // /collections/x/products.json: precios en pesos, como texto
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return null;
    var pesos = function (t) { return Math.round(parseFloat(t || '0') * 100); };
    return { id: p.id, titulo: p.title, url: '/products/' + p.handle, img: (p.images && p.images[0] && p.images[0].src) || '',
             precio: pesos(v.price), antes: pesos(v.compare_at_price), variante: v.id, tipo: p.product_type || '' };
  }

  function traer(url, norm) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j.products || []).map(norm).filter(Boolean); })
      .catch(function () { return []; });
  }

  function candidatos(carro, falta) {
    var enCarro = {};
    carro.items.forEach(function (i) { enCarro[i.product_id] = 1; });
    var ids = carro.items.map(function (i) { return i.product_id; }).filter(function (v, i, a) { return a.indexOf(v) === i; }).slice(0, 3);
    var pedidos = ids.map(function (id) {
      if (!cacheRec[id]) cacheRec[id] = traer('/recommendations/products.json?product_id=' + id + '&limit=10&intent=related', normalizarJs);
      return cacheRec[id];
    });
    if (C.coleccion && !cacheCol) cacheCol = traer('/collections/' + C.coleccion + '/products.json?limit=60', normalizarColeccion);
    return Promise.all(pedidos.concat([cacheCol || Promise.resolve([])])).then(function (listas) {
      var col = listas.pop();
      var rel = [].concat.apply([], listas);
      var sirve = function (p) {
        return p && !enCarro[p.id] && p.precio >= falta && p.precio > 0 && !/gift|regalo|tarjeta/i.test(p.tipo);
      };
      var porPrecio = function (a, b) { return a.precio - b.precio; };
      // Primero los relacionados que no se pasan mucho de lo que falta; después la colección curada;
      // al final los relacionados caros (medido 25/09: en unionx.cl salía una cámara de $124.990
      // para cerrar $47.000).
      var tope = Math.max(falta * 2, falta + 3000000);
      var relOk = rel.filter(sirve).sort(porPrecio);
      var visto = {}, out = [];
      relOk.filter(function (p) { return p.precio <= tope; })
        .concat(col.filter(sirve).sort(porPrecio), relOk.filter(function (p) { return p.precio > tope; })).forEach(function (p) {
        if (!visto[p.id] && out.length < 3) { visto[p.id] = 1; out.push(p); }
      });
      return out;
    });
  }

  // 🪤 El botón es un <a role="button">: el tema Icon estira todo <button> del carrito y tapaba el nombre.
  function html(lista, falta) {
    return '<p class="spx-completa__tit">Completa tu envío gratis</p>' +
      '<p class="spx-completa__sub">Te faltan ' + fmt(falta) + '. Con cualquiera de estos, tu despacho es gratis.</p>' +
      '<ul class="spx-completa__lista">' + lista.map(function (p) {
        var src = p.img ? p.img.replace(/^\/\//, 'https://') : '';
        if (src) src += (src.indexOf('?') < 0 ? '?' : '&') + 'width=120';
        return '<li class="spx-completa__item">' +
          (src ? '<img class="spx-completa__img" src="' + esc(src) + '" alt="" width="56" height="56" loading="lazy">' : '') +
          '<div class="spx-completa__info"><a class="spx-completa__nom" href="' + esc(p.url) + '">' + esc(p.titulo) + '</a>' +
          '<div class="spx-completa__precio">' + fmt(p.precio) + (p.antes > p.precio ? '<s>' + fmt(p.antes) + '</s>' : '') + '</div></div>' +
          '<a href="#" role="button" class="spx-completa__btn" data-spx-variante="' + p.variante + '">Agregar</a></li>';
      }).join('') + '</ul>';
  }

  function refrescarCarro(items) {
    if (C.tema === 'icon') {
      var el = document.getElementById('cart-config');
      var t = window.Shopify && Shopify.theme;
      if (el && t && t.cart && t.ajaxCart) {
        var cfg = JSON.parse(el.innerHTML || '{}');
        return t.cart.getCart().then(function (c) { t.ajaxCart.updateView(cfg, c); });
      }
      location.reload();
      return;
    }
    // Horizon: en la página del carro se recarga (la re-renderiza entera); en el cajón, el evento
    // nativo refresca contador y cajón. 🪤 El import va en un <script type="module"> creado en
    // tiempo de ejecución: el CDN minifica los .js del tema y rompe un import() dinámico.
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var usar = function (m) {
      if (!m || !m.CartLinesUpdateEvent) { location.reload(); return; }
      var d = m.CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'add', context: 'product',
        lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }), promise: d.promise }));
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) { var a = m.CartLinesUpdateEvent.createCartFromAjaxResponse; d.resolve({ cart: a ? a(c) : null, detail: { itemCount: c.item_count } }); })
        .catch(function (e) { d.reject(e); });
    };
    if (window.__lhxEventosShopify) return usar(window.__lhxEventosShopify);
    document.addEventListener('lhx:eventos-shopify', function () { usar(window.__lhxEventosShopify); }, { once: true });
    if (!document.getElementById('lhx-eventos-shopify')) {
      var s = document.createElement('script');
      s.type = 'module';
      s.id = 'lhx-eventos-shopify';
      s.textContent = "import * as m from '@shopify/events'; window.__lhxEventosShopify = m; document.dispatchEvent(new Event('lhx:eventos-shopify'));";
      document.head.appendChild(s);
    }
  }

  function agregar(btn) {
    var id = Number(btn.getAttribute('data-spx-variante'));
    var items = [{ id: id, quantity: 1 }];
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Agregando…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { btn.textContent = 'Agregado ✓'; firma = ''; return refrescarCarro(items); })
      .then(function () { setTimeout(pintar, 400); })
      .catch(function () { btn.removeAttribute('aria-disabled'); btn.textContent = 'Agregar'; });
  }

  // La barra del tema manda: si dice «Te faltan $23.000», eso es lo que falta aunque el umbral de acá
  // haya quedado viejo (el monto del envío gratis cambia en campañas). Si ya felicita, no falta nada.
  // 🪤 «$40.000» → se sacan los puntos de miles y recién ahí ×100 a centavos (no antes).
  function textoBarra(a) {
    var c = a.querySelector(':scope > .spx-completa');
    return (c ? a.textContent.replace(c.textContent, '') : a.textContent).replace(/\s+/g, ' ').trim();
  }
  // 25/09 (2ª auditoría): la caja iba dentro de la barra, que está ARRIBA del botón de pago, y lo bajaba
  // fuera de la primera pantalla en las 3 tiendas (celular: 785 → 1.081 px en Simplit, 751 → 1.053 en
  // unionx.cl; también en el cajón). Ahora va justo DESPUÉS del botón de pago de su mismo carro (página o
  // cajón). Si ese botón vive en un pie fijo (sticky abajo), se queda en la barra para no agrandar el pie.
  function destinoDe(a) {
    for (var x = a; x && x !== document.body; x = x.parentElement) {
      var b = x.querySelector(C.pagar || '[name=checkout]');
      if (!b) continue;
      for (var y = b.parentElement, i = 0; y && i < 4; y = y.parentElement, i++) {
        var s = getComputedStyle(y);  // pie fijo = sticky pegado ABAJO; la columna del resumen de Horizon es sticky pero arriba
        if (s.position === 'sticky' && s.bottom !== 'auto') return a;
      }
      return b.parentElement;
    }
    return a;
  }
  function cajaDe(a) { return destinoDe(a).querySelector(':scope > .spx-completa'); }

  function faltaSegunBarra(anclas) {
    for (var i = 0; i < anclas.length; i++) {
      var tx = textoBarra(anclas[i]);
      var m = tx.match(/\$\s?(\d{1,3}(?:\.\d{3})+|\d+)/);
      if (m) return parseInt(m[1].replace(/\./g, ''), 10) * 100;
      if (/felicit|ya tienes|tienes (el )?(env[ií]o|despacho) gratis/i.test(tx)) return 0;
    }
    return null;
  }

  function pintar() {
    if (trabajando) { pendiente = true; return; }
    var anclas = [];
    (C.anclas || []).forEach(function (sel) { [].forEach.call(document.querySelectorAll(sel), function (a) { if (a.offsetParent !== null || a.closest('dialog,aside,[class*=drawer]')) anclas.push(a); }); });
    if (!anclas.length) return;
    var f = anclas.map(textoBarra).join('|') + '#' + anclas.length + '#' + anclas.filter(cajaDe).length;
    if (f === firma) return;
    trabajando = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (carro) {
      var falta = faltaSegunBarra(anclas);
      if (falta == null) falta = C.umbral - carro.total_price;
      if (!carro.item_count || falta <= 0) return [];
      return candidatos(carro, falta).then(function (lista) { return lista.length ? [lista, falta] : []; });
    }).then(function (res) {
      anclas.forEach(function (a) {
        // 🪤 La caja va DENTRO de la barra, no como hermana: en Horizon el resumen del carro es una
        // grilla con `grid-template-rows: subgrid` de filas contadas, y un hijo extra montaba
        // «Documento tributario» sobre «Total estimado» en escritorio (medido 25/09 en unionx.cl).
        var caja = cajaDe(a);
        if (!res.length) { if (caja) caja.remove(); return; }
        if (!caja) { caja = document.createElement('div'); caja.className = 'spx-completa'; destinoDe(a).appendChild(caja); }
        caja.style.setProperty('--spx-c', C.color || '#2f2f2f');
        caja.innerHTML = html(res[0], res[1]);
      });
      firma = anclas.map(textoBarra).join('|') + '#' + anclas.length + '#' + (res.length ? anclas.length : 0);
    }).catch(function () {}).then(function () {
      trabajando = false;
      if (pendiente) { pendiente = false; setTimeout(pintar, 50); }
    });
  }

  estilos();
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.spx-completa__btn');
    if (b) { e.preventDefault(); if (b.getAttribute('aria-disabled') !== 'true') agregar(b); }
  });
  var t = null;
  new MutationObserver(function (muts) {
    // ignorar lo que cambia nuestra propia caja
    if (muts.every(function (m) { return m.target.closest && m.target.closest('.spx-completa'); })) return;
    clearTimeout(t); t = setTimeout(pintar, 300);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintar); else pintar();
})();
